import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchInputComponent } from './search-input.component';

@NgModule({
	declarations: [],
	imports: [SearchInputComponent],
	exports: [SearchInputComponent],
})
export class SearchInputModule {}
